import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll<HTMLElement>(".hero");

  sliders.forEach((sliderRoot) => {
    const nextBtn = sliderRoot.querySelector(".swiper-custom-next") as HTMLElement;
    const prevBtn = sliderRoot.querySelector(".swiper-custom-prev") as HTMLElement;

    const baseConfig = {
      modules: [Autoplay, Navigation],
      slidesPerView: 1,
      loop: true,
      speed: 600,
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    };

    const swiperElement = sliderRoot.querySelector<HTMLElement>(".swiper");
    if (!swiperElement) return console.error("Swiper-Element nicht gefunden in:", sliderRoot);

    new Swiper(swiperElement, baseConfig);
  });
});
